import React from 'react';
import { navigate } from 'gatsby';

//CORE COMPONENTS
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';
import styled from 'styled-components';

import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container/index';
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../components-core/packages/components-core/dist/text';

//CUSTOM COMPONENTS
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';





const TopContainer = styled.div`
    width: 100vw;
    
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;


class SelectCredit extends React.Component {

    renderTitle() {

        return (
            <Container 
                padding={padding4Dimensions} 
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <Text textAlign={TextAlignment.center} appearance={TextAppearance.headline0400}>
                    VDF Kredi Hesaplama
                    <Text bold appearance={TextAppearance.headline0400} >
                        Kredi Hesaplama
                    </Text>
                </Text>
            </Container>
        )
    }

    renderDescription() {

        return (
            <Container 
                padding={padding4Dimensions} 
                horizontalAlign={ContainerHorizontalAlignment.center} 
            >
                <Text textAlign={TextAlignment.center} appearance={TextAppearance.copy0200}>
                    Hayalinizdeki araca ulaşmanızı sağlayacak bütçenize en uygun kredi seçeneklerini keşfedebilirsiniz.
                </Text>
            </Container>
        )
    }

    renderButton() {

        return (
            <Container 
                horizontalAlign={ContainerHorizontalAlignment.center}
                padding={{ left: globalPadding, right: globalPadding }}
            >
                <Button appearance={ButtonAppearance.Primary} >
                    <Text appearance={TextAppearance.copy0150} color={TextColor.inherit}  >
                        Bilgi Al
                    </Text>  
                </Button>
            </Container>
        )
    }

    renderInnerContainer() {

        const mainContainerPadding = {
            top: ContainerPadding.dynamic0300,
            bottom: ContainerPadding.dynamic0300
        }

        return (
            <Container 
                padding={mainContainerPadding}
                horizontalAlign={ContainerHorizontalAlignment.center} 
            >
                <Container 
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    stretchContent={true}
                    wrap={ContainerWrap.always}
                >
                    {this.renderTitle()}
                    {this.renderDescription()}
                </Container>
            </Container>
        )
    }

    render() {

        return (
            <ThemeProvider theme={'main'} >
                <TopContainer>
                    {this.renderInnerContainer()}
                </TopContainer>   
            </ThemeProvider>
        )
    }
}

export default SelectCredit;

const globalPadding = {
    [Breakpoints.b1920]: ContainerPadding.grid007,
    [Breakpoints.b1600]: ContainerPadding.grid006,
    [Breakpoints.b1280]: ContainerPadding.grid005,
    [Breakpoints.b960]: ContainerPadding.grid004,
    [Breakpoints.default]: ContainerPadding.grid002
}

const padding4Dimensions = {
    left: globalPadding,
    right: globalPadding,
    bottom: ContainerPadding.dynamic0100
}

